var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row submissions" }, [
    _c("div", { staticClass: "small-12" }, [
      _c(
        "div",
        { staticClass: "submissions__topbar" },
        [
          _c(
            "Sticky",
            { attrs: { align: "right", stickyTop: 40, specifyWidth: "auto" } },
            [
              _vm._l(_vm.engineerButtons, function (item, index) {
                return [
                  _c(
                    "HKLButton",
                    {
                      key: index,
                      attrs: { color: item.color, disable: item.disable },
                      on: { click: item.func },
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(item.title) + "\n          "
                      ),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row small-12 submissions__container" },
      [
        _c("transition", { attrs: { name: "fade" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isCollapse,
                  expression: "isCollapse",
                },
              ],
              staticClass: "left-content",
            },
            [
              _c("TenantProjectDocuments", {
                attrs: {
                  projectDocsSrcId: _vm.projectDocsSrcId,
                  enableEdit: _vm.canEditDocument,
                  enableUpload: _vm.canUploadDocs,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sticky-box", class: { collapse: !_vm.isCollapse } },
          [
            _c(
              "Sticky",
              { attrs: { align: "none", specifyWidth: "auto", stickyTop: 40 } },
              [
                _c("i", {
                  staticClass: "sticky-angle fa",
                  class: [_vm.isCollapse ? "fa-angle-left" : "fa-angle-right"],
                  on: { click: _vm.triggerCollapse },
                }),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right-content" }, [
          _c(
            "div",
            { staticClass: "submission-comments-container" },
            [
              _vm.isTenant
                ? _c(
                    "SubmissionTabsContainer",
                    { attrs: { tabNames: _vm.tabNames } },
                    [
                      _vm.tenantVisibleSubmissions.length
                        ? _c("CommentsView", {
                            attrs: { slot: "tab-0" },
                            slot: "tab-0",
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("Guideline", {
                        attrs: {
                          slot: !_vm.tenantVisibleSubmissions.length
                            ? "tab-0"
                            : "tab-1",
                        },
                        slot: !_vm.tenantVisibleSubmissions.length
                          ? "tab-0"
                          : "tab-1",
                      }),
                    ],
                    1
                  )
                : _c(
                    "SubmissionTabsContainer",
                    { attrs: { tabNames: _vm.tabNames } },
                    [
                      _c("Comments", {
                        ref: "comments",
                        attrs: {
                          slot: "tab-0",
                          canCommentDesign: _vm.canCommentDesign && _vm.canEdit,
                          canCommentTech: _vm.canCommentTech && _vm.canEdit,
                          isTenant: _vm.isTenant,
                        },
                        slot: "tab-0",
                      }),
                      _vm._v(" "),
                      _c("Guideline", {
                        attrs: {
                          slot: "tab-1",
                          enableEdit: _vm.canEditGuideline,
                        },
                        slot: "tab-1",
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("CpCommentSubmitModal", {
          ref: "cpCommentSubmitModal",
          attrs: { confirmCallback: _vm.confirmSubmitCPComment },
        }),
        _vm._v(" "),
        _c("PreviewSubmissionModal", { ref: "previewSubmissionModal" }),
        _vm._v(" "),
        _c("ReassignSubmissionModal", {
          ref: "reassignSubmissionModal",
          attrs: { confirmCallback: _vm.confirmReassign },
        }),
        _vm._v(" "),
        _c("TenantNextReviewerModal", {
          ref: "nextReviewerModal",
          attrs: { confirmCallback: _vm.passToNextViewer },
        }),
        _vm._v(" "),
        _c("CancelBatchModal", { ref: "cancelBatchModalRef" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }